/* ENDQUOTE — product back-button fix (2026-09-19).
   On the product page the thumbnail_carousel gallery pollutes browser history two ways:
     (1) global.js sidebar() scroll-spy calls history.pushState() for each image as you
         scroll the page;
     (2) the sidebar thumbnails are <a href="#..."> anchors, so every click is a hash
         navigation that also adds a history entry.
   Either way the browser Back button then steps back through gallery images instead of
   returning to the previous page (e.g. the homepage). This self-contained patch
   neutralises both, on product pages only, without touching core theme JS.
   Revert by deleting this file and its <script> tag in layout/theme.liquid. */
(function () {
	if (!/\/products\//.test(location.pathname)) return;

	/* (1) Same-page, hash-only history pushes become replaces so they never stack.
	   Cross-page navigations (different pathname) are left untouched. */
	try {
		var nativePush = history.pushState;
		history.pushState = function (state, title, url) {
			try {
				if (url != null) {
					var u = new URL(url, location.href);
					if (u.pathname === location.pathname && u.hash) {
						return history.replaceState(state, title, url);
					}
				}
			} catch (e) {}
			return nativePush.apply(history, arguments);
		};
	} catch (e) {}

	/* (2) Sidebar thumbnail clicks: scroll to the image and replace (not push) the hash,
	   so clicking through thumbnails leaves the history stack untouched. */
	document.addEventListener(
		'click',
		function (e) {
			var a =
				e.target &&
				e.target.closest &&
				e.target.closest('.product__media-sublist__sidebar-nav a[href^="#"]');
			if (!a) return;
			var id = a.getAttribute('href');
			if (!id || id.length < 2) return;
			var target = null;
			try {
				target = document.querySelector(id);
			} catch (_) {}
			e.preventDefault();
			if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
			try {
				history.replaceState(null, '', id);
			} catch (_) {}
		},
		true
	);
})();
